import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Axios } from "../../../Api/axios";
import { ADMIN_ALL_CLASSES, ADMIN_DELETE_CLASS } from "../../../Api/Api";
import "../dash-cards.css";

function ClassCard({ cls, onDelete }) {
  const [deleting, setDeleting] = useState(false);

  async function handleDelete() {
    if (!window.confirm(`هل تريد حذف الصف "${cls.name}"؟`)) return;
    setDeleting(true);
    try { await onDelete(cls.id); }
    catch { setDeleting(false); }
  }

  return (
    <div className="dc-card">
      <div className="dc-card-cap" />
      <div className="dc-card-avatar">
        <div className="dc-card-avatar-placeholder dc-avatar-dark">
          <svg width="30" height="30" fill="currentColor" viewBox="0 0 24 24">
            <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
          </svg>
        </div>
      </div>

      <div className="dc-card-body">
        <h3 className="dc-card-name">{cls.name}</h3>
        <span className="dc-card-meta dc-card-meta-green">
          <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          </svg>
          صف دراسي
        </span>
      </div>

      <div className="dc-card-actions">
        <Link to={`/dashboard/classes/${cls.id}`} className="dc-action-btn dc-edit-btn">
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
          </svg>
          تعديل
        </Link>
        <button className="dc-action-btn dc-delete-btn" onClick={handleDelete} disabled={deleting}>
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          </svg>
          {deleting ? "..." : "حذف"}
        </button>
      </div>
    </div>
  );
}

function SkeletonCard() {
  return (
    <div className="dc-card dc-skeleton">
      <div className="dc-card-cap" />
      <div className="dc-card-avatar" />
      <div className="dc-card-body" style={{ paddingBottom: 14 }}>
        <div className="dc-sk-line dc-sk-lg" />
        <div className="dc-sk-line dc-sk-sm" />
      </div>
      <div className="dc-sk-actions">
        <div className="dc-sk-btn" style={{ borderBottomRightRadius: 18 }} />
        <div className="dc-sk-btn" style={{ borderBottomLeftRadius: 18 }} />
      </div>
    </div>
  );
}

export default function Classes() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES)
      .then((res) => setClasses(res.data.classes || res.data || []))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  async function handleDelete(id) {
    await Axios.delete(ADMIN_DELETE_CLASS(id));
    setClasses((prev) => prev.filter((item) => item.id !== id));
  }

  return (
    <div className="dash-page">
      <div className="dash-page-header">
        <h1 className="dash-page-title">الصفوف الدراسية</h1>
        <Link className="dash-add-btn" to="/dashboard/class/add">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
          إضافة صف جديد
        </Link>
      </div>

      <div className="card-grid">
        {loading ? (
          Array.from({ length: 4 }).map((_, i) => <SkeletonCard key={i} />)
        ) : classes.length === 0 ? (
          <div className="dc-empty">
            <svg width="56" height="56" fill="currentColor" viewBox="0 0 24 24">
              <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
            </svg>
            <p>لا توجد صفوف دراسية بعد</p>
            <small>ابدأ بإضافة صف جديد</small>
          </div>
        ) : (
          classes.map((cls) => (
            <ClassCard key={cls.id} cls={cls} onDelete={handleDelete} />
          ))
        )}
      </div>
    </div>
  );
}
